import { HeartBank } from "../../../managers/HeartBank.ts";
import template from "./hb-thank.mjs";
import { render } from "lit-html";
import {
    TREASURY,
    getRandomNumber,
    B,
    isIOS,
    getCircle,
    getKiitosSummary,
    TOKENS,
    getTipAmount2,
    getTipAmount,
    downloadFile,
    getAuraRing,
    getAuraName
} from "../../global.ts";
import { Kiito, Kiitos } from "../../../models/Thanks.ts";
import { Functions } from "../../../managers/Functions.ts";
import { Me } from "../../../managers/Me.ts";
import { Media } from "../../../managers/Media.ts";

import { Modal } from "flowbite";
import type { ModalOptions, ModalInterface } from "flowbite";
import type { InstanceOptions } from "flowbite";
import { HbMain } from "../hb-main.ts";

//import Strings from "../../../models/Strings.json";
//const strings: any = Strings;

import Stock from "./Treasury.json";
const stock: { category: string; folder: string; count: number }[] = Stock;

export class HbThank extends HTMLElement {
    private heartbank: HeartBank = new HeartBank();
    private me = new Me();
    private media = new Media();
    private kiitos = new Kiitos();
    private functions = new Functions();
    private modal: ModalInterface;
    private main = document.querySelector("hb-main") as HbMain;

    private jewelry: HTMLElement;
    private form: HTMLFormElement;
    private archive: HTMLButtonElement;
    private cover: HTMLVideoElement;
    private date: HTMLSpanElement;
    private views: HTMLSpanElement;

    private internalBtns: HTMLElement;
    private mineBtn: HTMLButtonElement;
    private mintBtn: HTMLButtonElement;

    private external2Btns: HTMLElement;
    private thankBtn: HTMLButtonElement;
    private rethankBtn: HTMLButtonElement;
    private thankallBtn: HTMLButtonElement; // thank both
    private newBtn: HTMLButtonElement;
    private externalBtns: HTMLElement;
    private shareBtn: HTMLButtonElement;
    private copyBtn: HTMLButtonElement;
    private tokenBtns: HTMLElement;

    private menu: HTMLElement;
    private pager: HTMLElement;
    private page: HTMLElement;
    private previous: HTMLButtonElement;
    private next: HTMLButtonElement;

    private party: HTMLElement;
    private from: HTMLSpanElement;
    private to: HTMLSpanElement;
    private arrow: HTMLSpanElement;
    private fromText: HTMLSpanElement;

    private photo: HTMLElement;
    private photoBtn: HTMLButtonElement;
    private photoFile: HTMLInputElement;
    private photoProgress: HTMLElement;
    private photoUpload: HTMLElement;
    private photoImageContainer: HTMLElement;
    private photoImage: HTMLImageElement;
    private photoRemove: HTMLButtonElement;
    private photoDownload: HTMLButtonElement;

    private short: HTMLElement;
    private shortBtn: HTMLButtonElement;
    private shortFile: HTMLInputElement;
    private shortProgress: HTMLElement;
    private shortUpload: HTMLElement;
    private shortVideoContainer: HTMLElement;
    private shortVideo: HTMLVideoElement;
    private shortRemove: HTMLButtonElement;
    private shortDownload: HTMLButtonElement;

    private stock: HTMLElement;
    private stockBtn: HTMLButtonElement;
    private stockImage: HTMLImageElement;

    private ai: HTMLElement;
    private aiBtn: HTMLButtonElement;
    private prompt: HTMLInputElement;
    private promptBtn: HTMLButtonElement;
    private aiImage: HTMLImageElement;

    private gold: HTMLTextAreaElement;
    private goldMenu: HTMLLabelElement;
    private goldLabel: HTMLLabelElement;
    private goldKarat: HTMLSpanElement;
    private goldCarat: HTMLSpanElement;
    private goldKiitos: HTMLSpanElement;
    private goldGratuity: HTMLSpanElement;
    private magic: HTMLButtonElement;
    private paste: HTMLButtonElement;
    private trash: HTMLButtonElement;

    private footer: HTMLElement;
    private footerDate: HTMLParagraphElement;
    private rethanks: HTMLSpanElement;

    private stockCategory = stock[0].folder;
    private stockItem = getRandomNumber(1, stock[0].count);
    private stockCount = stock[0].count;

    private aiItem = 0;
    private aiCount = 0;

    private hasPasskey = false;
    private thank: Kiito | null = null;
    private jewel: "photo" | "short" | "ai" | "stock" = "stock";

    constructor() {
        super();
        render(template(null), this);

        this.jewelry = this.querySelector("#hb-thank")!;
        this.form = this.querySelector("#hb-thank-form")!;
        this.archive = this.querySelector("#hb-thank-archive")!;
        this.cover = this.querySelector("#hb-thank-cover")!;
        this.date = this.querySelector("#hb-thank-date")!;
        this.views = this.querySelector("#hb-thank-views")!;

        this.internalBtns = this.querySelector("#hb-thank-internal")!;
        this.mintBtn = this.querySelector("#hb-thank-mint")!;
        this.mineBtn = this.querySelector("#hb-thank-mine")!;

        this.external2Btns = this.querySelector("#hb-thank-external2")!;
        this.thankBtn = this.external2Btns
            .firstElementChild as HTMLButtonElement;
        this.rethankBtn = this.querySelector("#hb-thank-rethank")!;
        this.thankallBtn = this.querySelector("#hb-thank-thankall")!;
        this.newBtn = this.external2Btns.lastElementChild as HTMLButtonElement;
        this.externalBtns = this.querySelector("#hb-thank-external")!;
        this.shareBtn = this.querySelector("#hb-thank-share")!;
        this.copyBtn = this.querySelector("#hb-thank-copy")!;
        this.tokenBtns = this.querySelector("#hb-thank-tokens")!;

        this.menu = this.querySelector("#hb-thank-menu")!;
        this.pager = this.querySelector("#hb-thank-menu-pager")!;
        this.page = this.querySelector("#hb-thank-menu-page")!;
        this.previous = this.querySelector("#hb-thank-menu-previous")!;
        this.next = this.querySelector("#hb-thank-menu-next")!;

        this.party = this.querySelector("#hb-thank-party")!;
        this.from = this.querySelector("#hb-thank-party-from")!;
        this.to = this.querySelector("#hb-thank-party-to")!;
        this.arrow = this.querySelector("#hb-thank-party-arrow")!;
        this.fromText = this.querySelector("#hb-thank-party-from-text")!;

        this.photo = this.querySelector("#hb-thank-photo")!;
        this.photoBtn = this.querySelector("#hb-thank-menu-photo")!;
        this.photoFile = this.querySelector("#hb-thank-photo-file")!;
        this.photoProgress = this.querySelector("#hb-thank-photo-progress")!;
        this.photoUpload = this.querySelector("#hb-thank-photo-upload")!;
        this.photoImage = this.querySelector("#hb-thank-photo-image")!;
        this.photoRemove = this.querySelector("#hb-thank-photo-remove")!;
        this.photoImageContainer = this.photoImage.parentElement as HTMLElement;
        this.photoDownload = this.querySelector("#hb-thank-photo-download")!;

        this.short = this.querySelector("#hb-thank-short")!;
        this.shortBtn = this.querySelector("#hb-thank-menu-short")!;
        this.shortFile = this.querySelector("#hb-thank-short-file")!;
        this.shortProgress = this.querySelector("#hb-thank-short-progress")!;
        this.shortUpload = this.querySelector("#hb-thank-short-upload")!;
        this.shortVideo = this.querySelector("#hb-thank-short-video")!;
        this.shortRemove = this.querySelector("#hb-thank-short-remove")!;
        this.shortVideoContainer = this.shortVideo.parentElement as HTMLElement;
        this.shortDownload = this.querySelector("#hb-thank-short-download")!;

        this.stock = this.querySelector("#hb-thank-stock")!;
        this.stockBtn = this.querySelector("#hb-thank-menu-stock")!;
        this.stockImage = this.querySelector("#hb-thank-stock-image")!;

        this.ai = this.querySelector("#hb-thank-ai")!;
        this.aiBtn = this.querySelector("#hb-thank-menu-ai")!;
        this.prompt = this.querySelector("#hb-thank-ai-prompt")!;
        this.promptBtn = this.querySelector("#hb-thank-ai-magic")!;
        this.aiImage = this.querySelector("#hb-thank-ai-image")!;

        this.gold = this.querySelector("#hb-thank-gold")!;
        this.goldMenu = this.querySelector("#hb-thank-gold-menu")!;
        this.goldLabel = this.querySelector("#hb-thank-gold-label")!;
        this.goldKarat = this.querySelector("#hb-thank-gold-karat")!;
        this.goldCarat = this.querySelector("#hb-thank-gold-carat")!;
        this.goldKiitos = this.querySelector("#hb-thank-gold-kiitos")!;
        this.goldGratuity = this.querySelector("#hb-thank-gold-gratuity")!;
        this.magic = this.querySelector("#hb-thank-gold-magic")!;
        this.paste = this.querySelector("#hb-thank-gold-paste")!;
        this.trash = this.querySelector("#hb-thank-gold-trash")!;

        this.footer = this.querySelector("#hb-thank-footer")!;
        this.footerDate = this.querySelector("#hb-thank-footer-date")!;
        this.rethanks = this.querySelector("#hb-thank-footer-rethanks")!;

        const modalOptions: ModalOptions = {
            placement: "center",
            backdrop: "dynamic",
            backdropClasses:
                "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40",
            closable: true,
            onHide: () => {
                this.cover.muted = true;
                this.shortVideo.muted = true;
                //window.location.hash = "#";
            },
            onShow: () => {
                // need user interaction
                //if (this.stockImage.paused) this.stockImage.play();
                //if (this.aiImage.paused) this.aiImage.play();
                //console.log("modal is shown");
            },
            onToggle: () => {
                //console.log("modal has been toggled");
            }
        };

        // instance options object
        const instanceOptions: InstanceOptions = {
            id: "hb-thank",
            override: true
        };

        this.modal = new Modal(this.jewelry, modalOptions, instanceOptions);
    }

    connectedCallback() {
        //this.renderStock();
        this.addPhotoListeners();
        this.addShortListeners();
        this.addStockListeners();
        this.addAIListeners();
        this.addGoldListeners();
        this.addFooterListeners();

        this.date.addEventListener("click", () => {
            const date = this.thank?.dateMined
                ? "mined on " +
                  this.thank.dateMined.toDate().toFormattedString()
                : this.thank?.dateMinted
                  ? "minted on " +
                    this.thank.dateMinted.toDate().toFormattedString()
                  : "";
            alert("💛 This B-Thank was " + date);
        });

        this.archive.addEventListener("click", () =>
            alert("B-Treasury coming soon!")
        );

        this.previous.addEventListener("click", () => {
            this.goToStock(false);
        });

        this.next.addEventListener("click", () => {
            this.goToStock(true);
        });

        this.from.addEventListener("click", async () => {
            const profile = await this.me.getUserProfile(this.thank?.from!);
            const name = this.me.getName2(profile);
            const [sign, karat] = profile.kiitos?.numberTuple() || ["", "Zero"];
            if (
                confirm(
                    `${getAuraRing(profile.kiitosFrequency || 0, true)} ${name}'s current Kiitos Aura is ${getAuraName(profile.kiitosFrequency || 0)}\n\n${getCircle(profile.kiitos || 0, true)} ${name}'s current Kiitos Balance is ${sign + karat} ${getKiitosSummary(
                        profile.kiitos || 0,
                        name
                    )}\n\nWould you like to watch ${name}'s B-Shorts?`
                )
            )
                window.open("https://id.333.eco", "_blank");
        });

        this.to.addEventListener("click", async () => {
            const profile = await this.me.getUserProfile(this.thank?.to!);
            const name = this.me.getName2(profile);
            const [sign, karat] = profile.kiitos?.numberTuple() || ["", "Zero"];
            if (
                confirm(
                    `${getAuraRing(profile.kiitosFrequency || 0, true)} ${name}'s current Kiitos Aura is ${getAuraName(profile.kiitosFrequency || 0)}\n\n${getCircle(profile.kiitos || 0, true)} ${name}'s current Kiitos Balance is ${sign + karat} ${getKiitosSummary(
                        profile.kiitos || 0,
                        name
                    )}\n\nWould you like to watch ${name}'s B-Shorts?`
                )
            )
                window.open("https://id.333.eco", "_blank");
        });

        this.heartbank.addAuthStateListener(async (user) => {
            render(template(user), this);
            if (user)
                this.hasPasskey = (await this.heartbank.passKeysCount()) > 0;
        });
    }

    private resetMenu() {
        this.photoBtn.classList.remove("underline", "uppercase");
        this.shortBtn.classList.remove("underline", "uppercase");
        this.aiBtn.classList.remove("underline", "uppercase");
        this.stockBtn.classList.remove("underline", "uppercase");

        this.photo.classList.add("hidden");
        this.short.classList.add("hidden");
        this.ai.classList.add("hidden");
        this.stock.classList.add("hidden");

        this.pager.classList.add("hidden");
        this.pager.classList.remove("inline-flex");
    }

    private addPhotoListeners() {
        this.photoBtn.addEventListener("click", () => {
            this.jewel = "photo";
            this.resetMenu();
            this.photoBtn.classList.add("underline", "uppercase");
            this.photo.classList.remove("hidden");
        });

        this.photoFile.addEventListener("change", async () => {
            if (this.heartbank.user && this.hasPasskey) {
                this.main.showSpinner();
                this.photoFile.disabled = true;
                if (this.photoFile.files && this.photoFile.files.length > 0) {
                    const progress = this.photoProgress
                        .parentElement as HTMLElement;
                    this.photoProgress.style.width = "0%";
                    this.photoProgress.textContent = "0%";
                    progress.classList.remove("hidden");
                    try {
                        const photo = await this.media.createPhotoFromFile(
                            this.photoFile.files[0]
                        );
                        this.photoImage.src = await this.media.storeFile(
                            photo.name,
                            photo,
                            (percent) => {
                                this.photoProgress.style.width = percent + "%";
                                this.photoProgress.textContent = `${percent}%`; // Uploading:
                            }
                        );
                        localStorage.setItem(
                            "thank-photo",
                            this.photoImage.src
                        );
                        this.photoImageContainer.classList.remove("hidden");
                        this.photoUpload.classList.add("hidden");
                    } catch (error: any) {
                        alert(error.message);
                    } finally {
                        progress.classList.add("hidden");
                    }
                }
                this.photoFile.disabled = false;
                this.main.hideSpinner();
            } else {
                if (this.heartbank.user) {
                    if (
                        confirm(
                            "Passkey is required to mint a B-Thank.\n\nWould you like to create one now?"
                        )
                    ) {
                        localStorage.setItem(
                            "redirect-lockbox",
                            window.location.hash
                        );
                        window.location.hash = "#/lockbox";
                    }
                } else {
                    if (
                        confirm(
                            "You need to be logged in to mint a B-Thank.\n\nWould you like to log in now?"
                        )
                    ) {
                        localStorage.setItem(
                            "redirect-login",
                            window.location.hash
                        );
                        window.location.hash = "#/login";
                    }
                }
            }
        });

        this.photoDownload.addEventListener("click", async () => {
            this.photoDownload.disabled = true;
            await downloadFile("B-Photo", this.photoImage.src); // extension auto added
            this.photoDownload.disabled = false;
        });

        this.photoRemove.addEventListener("click", async () => {
            if (confirm("Would you like to remove this photo?")) {
                this.main.showSpinner();
                this.photoRemove.disabled = true;

                await this.media.removeFile(this.photoImage.src);
                localStorage.removeItem("thank-photo");
                this.photoFile.value = "";
                this.photoImageContainer.classList.add("hidden");
                this.photoUpload.classList.remove("hidden");

                this.photoRemove.disabled = false;
                this.main.hideSpinner();
            }
        });
    }

    private addShortListeners() {
        this.shortBtn.addEventListener("click", () => {
            this.jewel = "short";
            this.resetMenu();
            this.shortBtn.classList.add("underline", "uppercase");
            this.short.classList.remove("hidden");
        });

        this.shortFile.addEventListener("change", async () => {
            if (this.heartbank.user && this.hasPasskey) {
                this.main.showSpinner();
                this.shortFile.disabled = true;
                if (this.shortFile.files && this.shortFile.files.length > 0) {
                    const progress = this.shortProgress
                        .parentElement as HTMLElement;
                    this.shortProgress.style.width = "0%";
                    this.shortProgress.textContent = "0%";
                    progress.classList.remove("hidden");
                    try {
                        const short = this.shortFile.files[0];
                        const result =
                            await this.media.validateVideoFile(short);
                        if (result.isValid && result.poster) {
                            this.shortVideo.poster = await this.media.storeFile(
                                result.poster.name,
                                result.poster,
                                (percent) => {
                                    this.shortProgress.style.width =
                                        percent + "%";
                                    this.shortProgress.textContent = `${percent}%`; // Uploading poster:
                                }
                            );
                            localStorage.setItem(
                                "thank-poster",
                                this.shortVideo.poster
                            );
                            this.shortVideo.src = await this.media.storeFile(
                                short.name,
                                short,
                                (percent) => {
                                    this.shortProgress.style.width =
                                        percent + "%";
                                    this.shortProgress.textContent = `${percent}%`; // Uploading video:
                                }
                            );
                            localStorage.setItem(
                                "thank-short",
                                this.shortVideo.src
                            );
                            this.shortVideoContainer.classList.remove("hidden");
                            this.shortUpload.classList.add("hidden");
                        } else alert(result.errorMessage);
                    } catch (error: any) {
                        alert(error.message);
                    } finally {
                        progress.classList.add("hidden");
                    }
                }
                this.shortFile.disabled = false;
                this.main.hideSpinner();
            } else {
                if (this.heartbank.user) {
                    if (
                        confirm(
                            "Passkey is required to mint a B-Thank.\n\nWould you like to create one now?"
                        )
                    ) {
                        localStorage.setItem(
                            "redirect-lockbox",
                            window.location.hash
                        );
                        window.location.hash = "#/lockbox";
                    }
                } else {
                    if (
                        confirm(
                            "You need to be logged in to mint a B-Thank.\n\nWould you like to log in now?"
                        )
                    ) {
                        localStorage.setItem(
                            "redirect-login",
                            window.location.hash
                        );
                        window.location.hash = "#/login";
                    }
                }
            }
        });

        this.shortDownload.addEventListener("click", async () => {
            this.shortDownload.disabled = true;
            await downloadFile("B-Short", this.shortVideo.src); // extension auto added
            this.shortDownload.disabled = false;
        });

        this.shortRemove.addEventListener("click", async () => {
            if (confirm("Would you like to remove this short?")) {
                this.main.showSpinner();
                this.shortRemove.disabled = true;

                await this.media.removeFile(this.shortVideo.poster);
                await this.media.removeFile(this.shortVideo.src);
                localStorage.removeItem("thank-poster");
                localStorage.removeItem("thank-short");
                this.shortFile.value = "";
                this.shortVideoContainer.classList.add("hidden");
                this.shortUpload.classList.remove("hidden");

                this.shortRemove.disabled = false;
                this.main.hideSpinner();
            }
        });
    }

    private addStockListeners() {
        this.stockBtn.addEventListener("click", () => {
            this.jewel = "stock";
            this.resetMenu();
            this.stockBtn.classList.add("underline", "uppercase");
            this.stock.classList.remove("hidden");
            this.pager.classList.remove("hidden");
            this.pager.classList.add("inline-flex");
        });
    }

    private addAIListeners() {
        this.aiBtn.addEventListener("click", () => {
            this.jewel = "ai";
            this.resetMenu();
            this.aiBtn.classList.add("underline", "uppercase");
            this.ai.classList.remove("hidden");
            //this.menu.classList.remove("hidden");
            //this.pager.classList.add("inline-flex");
            //this.prompt.focus();
        });
    }

    private addGoldListeners() {
        this.gold.addEventListener("input", () => {
            localStorage.setItem("thank-gold", this.gold.value);
        });

        this.magic.addEventListener("click", () => {
            if (
                this.gold.value.trim() === "" ||
                confirm(
                    "Would you like Miss Aquarius™ AI to improve your gratitude note?"
                )
            ) {
                this.gold.value = "Thank You!";
                localStorage.setItem("thank-gold", this.gold.value);
                this.gold.focus();
            }
            //alert("AI writing assistant coming soon...");
        });

        this.paste.addEventListener("click", async () => {
            if (
                this.gold.value.trim() === "" ||
                confirm(
                    "Would you like to replace your gratitude note with the one you copied to your clipboard?"
                )
            ) {
                this.gold.value = await navigator.clipboard.readText();
                localStorage.setItem("thank-gold", this.gold.value);
                this.gold.focus();
            }
        });

        this.trash.addEventListener("click", () => {
            if (
                this.gold.value &&
                confirm(
                    "Would you like to clear your gratitude note and start over?"
                )
            ) {
                this.gold.value = "";
                localStorage.setItem("thank-gold", this.gold.value);
                this.gold.focus();
            }
        });
    }

    private getJewel() {
        switch (this.jewel) {
            case "photo":
                return this.photoImage.src || this.stockImage.src;
            case "short":
                return this.shortVideo.poster || this.stockImage.src;
            case "ai":
                return this.stockImage.src; // this.aiImage.src;
            case "stock":
                return this.stockImage.src;
        }
    }

    private getDiamond() {
        switch (this.jewel) {
            case "photo":
                return "";
            case "short":
                return this.shortVideo.src;
            case "ai":
                return "";
            case "stock":
                return "";
        }
    }

    private getType() {
        switch (this.jewel) {
            case "photo":
                return localStorage.getItem("thank-photo") ? "photo" : "stock";
            case "short":
                return localStorage.getItem("thank-short") ? "short" : "stock"; // check thank-poster ?
            case "ai":
                return "stock";
            case "stock":
                return "stock";
        }
    }

    private async cleanUp() {
        const photo = localStorage.getItem("thank-photo");
        const poster = localStorage.getItem("thank-poster");
        const short = localStorage.getItem("thank-short");

        switch (this.jewel) {
            case "photo":
                if (poster) await this.media.removeFile(poster);
                if (short) await this.media.removeFile(short);
                break;
            case "short":
                if (photo) await this.media.removeFile(photo);
                break;
            case "ai":
                if (photo) await this.media.removeFile(photo);
                if (poster) await this.media.removeFile(poster);
                if (short) await this.media.removeFile(short);
                break;
            case "stock":
                if (photo) await this.media.removeFile(photo);
                if (poster) await this.media.removeFile(poster);
                if (short) await this.media.removeFile(short);
                break;
        }

        localStorage.removeItem("thank-photo");
        localStorage.removeItem("thank-poster");
        localStorage.removeItem("thank-short");
        localStorage.removeItem("thank-gold");

        this.photoImageContainer.classList.add("hidden");
        this.photoUpload.classList.remove("hidden");
        this.shortVideoContainer.classList.add("hidden");
        this.shortUpload.classList.remove("hidden");
    }

    private addFooterListeners() {
        this.mintBtn.addEventListener("click", async () => {
            this.main.showSpinner();
            this.mintBtn.disabled = true;
            if (this.heartbank.user && this.hasPasskey) {
                const response = await this.kiitos.mint(
                    this.gold.value.trim(),
                    this.getJewel(),
                    this.getDiamond(),
                    this.shortVideo.duration || 0,
                    this.getType()
                );
                if (response.data) {
                    await this.cleanUp();
                    const balance = response.data.balance || 0;
                    const [sign, karat] = balance.numberTuple(); //|| ["", "Zero"];
                    alert(
                        `🎉 You have successfully minted this B-Thank!\n\n💌 Now SHARE IT with your INTENDED RECIPIENT!\n\n💚 Your New Kiitos Balance will be ${sign + karat} once your recipient has mined your B-Thank.\n\n${this.aquarius(
                            balance
                        )}`
                    );
                    // alert(
                    //     `🎉 You have successfully minted this B-Thank!\n\n💌 Now SHARE IT with your INTENDED RECIPIENT!\n\n💚 Your New Kiitos Balance will be ${sign}${karat} once your recipient has mined your B-Thank.\n\n${this.aquarius(
                    //         "gratitude",
                    //         "someone"
                    //     )}`
                    // );
                    window.location.hash = `#/thank/${response.data.id}`;
                } else if (response.color === "red") alert(response.text);
            } else {
                if (this.heartbank.user) {
                    if (
                        confirm(
                            "Passkey is required to mint a B-Thank.\n\nWould you like to create one now?"
                        )
                    ) {
                        localStorage.setItem(
                            "redirect-lockbox",
                            window.location.hash
                        );
                        window.location.hash = "#/lockbox";
                    }
                } else {
                    if (
                        confirm(
                            "You need to be logged in to mint a B-Thank.\n\nWould you like to log in now?"
                        )
                    ) {
                        localStorage.setItem(
                            "redirect-login",
                            window.location.hash
                        );
                        window.location.hash = "#/login";
                    }
                }
            }
            this.mintBtn.disabled = false;
            this.main.hideSpinner();
        });

        this.mineBtn.addEventListener("click", async () => {
            this.main.showSpinner();
            this.mineBtn.disabled = true;
            if (this.heartbank.user && this.hasPasskey) {
                if (this.thank && this.thank.from !== this.heartbank.user.uid) {
                    const response = await this.kiitos.mine(this.thank.id!);
                    if (response.color === "green") {
                        const profile = await this.me.getUserProfile(
                            this.thank?.from!
                        );

                        await this.functions.notify(this.thank.id!);
                        this.alertSuccess(
                            this.me.getName2(profile),
                            profile.kiitos || 0,
                            response.kiitos || 0
                        );

                        const event = new CustomEvent("hb-treasury", {
                            detail: {
                                isShow: false
                            },
                            bubbles: true,
                            composed: true
                        });
                        this.dispatchEvent(event);

                        await this.show(this.thank.id!);
                    } else if (response.color === "red") alert(response.text);
                } else {
                    alert("Sorry, you cannot mine your own B-Thank.");
                }
            } else {
                if (this.heartbank.user) {
                    if (
                        confirm(
                            "Passkey is required to mine this B-Thank. \n\nWould you like to create one now?"
                        )
                    ) {
                        localStorage.setItem(
                            "redirect-lockbox",
                            window.location.hash
                        );
                        window.location.hash = "#/lockbox";
                    }
                } else {
                    if (
                        confirm(
                            "You need to be logged in to mine this B-Thank.\n\nWould you like to log in now?"
                        )
                    ) {
                        localStorage.setItem(
                            "redirect-login",
                            window.location.hash
                        );
                        window.location.hash = "#/login";
                    }
                }
            }
            this.mineBtn.disabled = false;
            this.main.hideSpinner();
        });

        //this.form.addEventListener("submit", this.share.bind(this));
        this.shareBtn.addEventListener("click", this.share.bind(this));

        this.copyBtn.addEventListener("click", async (event) => {
            try {
                // We wrap the async call in a Promise that returns a Blob
                const clipboardItem = new ClipboardItem({
                    "text/plain": this.getText(false).then((text) => {
                        return new Blob([text], { type: "text/plain" });
                    })
                });

                // We write the item immediately.
                // The browser handles the "waiting" for the getText() promise internally.
                await navigator.clipboard.write([clipboardItem]);

                alert("This B-Thank has been copied to your clipboard!");
            } catch (err) {
                console.error("Clipboard move failed:", err);
                // Fallback for older browsers or permission denials
                alert(
                    "Copy failed. Please try again or ensure the site has clipboard permissions."
                );
            }
        });

        // this.copyBtn.addEventListener("click", async (event) => {
        //     await navigator.clipboard.writeText(await this.getText(false)); // cannot do link first bc weird bug
        //     alert("This B-Thank has been copied to your clipboard!");
        // });

        this.newBtn.addEventListener(
            "click",
            () => (window.location.hash = "#/thank")
        );

        this.thankBtn.addEventListener("click", async () => {
            await this.renderTokens(this.thank?.from!);
            this.externalBtns.classList.add("hidden");
            this.external2Btns.classList.add("hidden");
            this.tokenBtns.classList.remove("hidden");
            //this.thankBtn.classList.add("hidden");
            this.jewelry.scrollTo({
                top: this.jewelry.scrollHeight,
                behavior: "smooth"
            });
        });

        this.rethankBtn.addEventListener("click", async () => {
            await this.renderTokens(this.thank?.to!);
            this.externalBtns.classList.add("hidden");
            this.external2Btns.classList.add("hidden");
            this.tokenBtns.classList.remove("hidden");
            //this.thankBtn.classList.add("hidden");
            this.jewelry.scrollTo({
                top: this.jewelry.scrollHeight,
                behavior: "smooth"
            });
        });

        this.thankallBtn.addEventListener("click", async () => {
            await this.renderTokens("");
            this.externalBtns.classList.add("hidden");
            this.external2Btns.classList.add("hidden");
            this.tokenBtns.classList.remove("hidden");
            //this.thankBtn.classList.add("hidden");
            this.jewelry.scrollTo({
                top: this.jewelry.scrollHeight,
                behavior: "smooth"
            });
        });
    }

    private alertSuccess(
        fromName: string,
        fromBalance: number,
        toBalance: number
    ) {
        const [fromSign, fromKarat] = fromBalance.numberTuple() || ["", 0];
        const [toSign, toKarat] = toBalance.numberTuple() || ["", 0];

        alert(
            `🎉 You have successfully mined ${fromName}'s B-Thank to you!\n\n🌎 Your kindness is now published on the Aquarius™ Blockchain and broadcasted to inspire the world!\n\n${getCircle(
                fromBalance,
                true
            )} Your New Kiitos Balance is ${toSign + toKarat} ${getKiitosSummary(
                toBalance
            )}\n\n${getCircle(
                fromBalance,
                true
            )} ${fromName}'s New Kiitos Balance is ${fromSign + fromKarat} ${getKiitosSummary(
                fromBalance,
                fromName
            )}\n\n${this.aquarius(toBalance)}`
        );
        // if (
        //     confirm(
        //         `🎉 You have successfully mined ${from}'s B-Thank to you!\n\n🌎 Your kindness is now published on the Aquarius™ Blockchain and broadcasted to inspire the world!\n\n${getCircle(
        //             balance,
        //             true
        //         )} Your New Kiitos Balance is ${sign + karat} ${getKiitosSummary(
        //             balance
        //         )}\n\n${getCircle(
        //             profile.kiitos,
        //             true
        //         )} ${from}'s New Kiitos Balance is ${fromSign + fromKarat} ${getKiitosSummary(
        //             profile.kiitos,
        //             from
        //         )}\n\n${this.aquarius(balance, true)}`
        //     )
        // ) {
        //     if (balance === 0) {
        //         window.location.hash = "#/thank";
        //     } else if (balance < 0) {
        //         window.location.hash = "#/thank"; //TODO: #/donate
        //     } else {
        //         window.location.hash = "#/thank";
        //     }
        // }
        // if (
        //     confirm(
        //         `🎉 You have successfully mined this B-Thank!\n\n🌎 It is now published on the Aquarius™ Blockchain and broadcasted to the entire world!\n\n${getCircle(balance), true} Your New Kiitos Balance is ${sign}${karat} ${}\n\n${this.aquarius(
        //             "kindness",
        //             this.me.getName2(profile)
        //         )}`
        //     )
        // )
        //     window.location.hash = "#/thank";
    }

    private aquarius(balance: number, isMining = false) {
        if (balance === 0)
            return (
                "😇 By returning back to Zero, your Aura Color has grown!\n\n♒️ To grow it further, continue to mint B-Thanks for people who have touched your heart, and mine B-Thanks that are given to you in gratitude." +
                (isMining ? "\n\n💛 Would you like to mint one now?" : "")
            );
        else if (balance < 0)
            return (
                "♒️ Please carry your gratitude forward by showing kindness to others to earn their B-Thanks and return back to Zero!" +
                (isMining
                    ? "\n\n🩵 Would you like to donate to Someone's B-Fund now to give them the gift of giving?"
                    : "")
            );
        else
            return (
                "♒️ Please carry the gratitude that others have shown to you forward by minting B-Thanks for others in appreciation to return back to Zero!" +
                (isMining ? "\n\n💛 Would you like to mint one now?" : "")
            );
    }

    // people nearby => use in anonymous nearby thanking
    private aquarius2(flow: "gratitude" | "kindness", name: string) {
        switch (flow) {
            case "gratitude":
                return `♒️ Please carry your gratitude forward by showing kindness to others to earn their B-Thanks and return back to Zero!`; //\n\n🩷 Would you like to donate to ${name}'s B-Fund now to give them the gift of giving?
            case "kindness":
                return `♒️ Please carry ${name}'s gratitude for you forward by minting B-Thanks for others in appreciation to return back to Zero!\n\n💛 Would you like to mint one now?`;
        }
    }

    private getCarat() {
        switch (this.thank?.type) {
            case "photo":
                return "Photo";
            case "short":
                return `Short lasting ${Math.round(
                    this.cover.duration
                )} seconds`;
            case "ai":
                return "AI Word Art";
            case "stock":
                return "Stock Word Art";
        }
    }

    async show(id: string) {
        this.main.showSpinner();
        if (id) {
            this.thank = await this.kiitos.get(id);
            if (this.thank) {
                const views = this.views.parentElement
                    ?.lastElementChild as HTMLSpanElement;
                const digs = this.thank.digs || 0;
                const scans = this.thank.scans || 0;
                this.views.textContent = (digs + scans).toString();
                views.textContent =
                    "View" + (this.views.textContent === "1" ? "" : "s");

                this.views.classList.remove("hidden");
                this.menu.classList.add("hidden");
                this.archive.classList.add("hidden");
                this.date.classList.remove("hidden");

                this.party.classList.remove("hidden");
                this.from.innerHTML = `<hb-me class="ml-0" uid="${this.thank.from}"></hb-me>`;
                if (this.thank.to) {
                    this.to.innerHTML = `<hb-me class="ml-0" uid="${this.thank.to}"></hb-me>`;
                    this.to.classList.remove("hidden");
                    this.arrow.classList.remove("hidden");
                    this.fromText.classList.add("hidden");
                } else {
                    this.to.classList.add("hidden");
                    this.arrow.classList.add("hidden");
                    this.fromText.classList.remove("hidden");
                }

                this.resetMenu();
                this.cover.poster = this.thank.jewel;
                if (this.thank.diamond) {
                    this.cover.src = this.thank.diamond;
                    this.cover.controls = true;

                    this.cover.removeAttribute("controlsList");
                    this.cover.style.pointerEvents = "";
                    this.cover.onclick = () => {};
                } else {
                    this.cover.removeAttribute("src");
                    this.cover.controls = false;
                    this.cover.load(); // needed to clear previous video

                    this.cover.setAttribute(
                        "controlsList",
                        "nodownload nofullscreen noremoteplayback"
                    );
                    this.cover.style.pointerEvents = "none";
                    this.cover.onclick = () => this.cover.pause();
                }
                this.cover.classList.remove("hidden");

                this.goldMenu.classList.add("hidden");
                this.goldMenu.classList.remove("inline-flex");
                this.goldLabel.classList.remove("hidden");
                this.goldLabel.classList.add("inline-flex");
                this.goldKiitos.textContent =
                    this.thank.kiitos?.toString() || "0";

                const goldTitle = this.goldLabel
                    .firstElementChild as HTMLSpanElement;
                goldTitle.onclick = () => {
                    const kiitos =
                        (this.thank?.kiitos || 0) -
                        (this.thank?.rekiitos?.reduce((t, i) => t + i) || 0);
                    alert(
                        `♒️ Miss Aquarius™ AI impartially weighs each B-Thank for depth of gratitude and act of kindness and this one equals ${kiitos} Kiitos`
                    );
                };

                const fromName = await this.me.getName3(this.thank.from!);
                const toName = this.thank.to
                    ? await this.me.getName3(this.thank.to)
                    : "";

                const gold = this.goldKiitos.parentElement as HTMLSpanElement;
                gold.onclick = () => {
                    let fromTotal = 0,
                        toTotal = 0;
                    if (this.thank?.rekiitos)
                        for (const [
                            index,
                            kiitos
                        ] of this.thank.rekiitos.entries()) {
                            if (this.thank?.isthanks?.[index])
                                fromTotal += kiitos;
                            else toTotal += kiitos;
                        }
                    toTotal +=
                        (this.thank?.kiitos || 0) - (fromTotal + toTotal); // original kiitos

                    alert(
                        `💛 ${fromName} received ${fromTotal} Kiitos in total` +
                            (toName
                                ? `\n\n💛 ${toName} received ${toTotal} Kiitos in total`
                                : "")
                    );
                };

                const total =
                    (this.thank.tip || 0) +
                    (this.thank.jar || 0) +
                    (this.thank.kitty || 0) +
                    (this.thank.pool || 0);
                const gratuity = this.goldGratuity
                    .parentElement as HTMLSpanElement;
                gratuity.classList.toggle("hidden", !total);
                this.goldGratuity.textContent = total.toCashAmount();
                gratuity.onclick = () => {
                    alert(
                        `💰 ${fromName}'s Retip B-Fund collected ${(this.thank?.kitty || 0).toCashAmount3()} in total donations` +
                            (toName
                                ? `\n\n🧧 ${toName}'s Personal B-Account collected ${(this.thank?.tip || 0).toCashAmount3()} in total tips\n\n💰 ${toName}'s Retip B-Fund collected ${(this.thank?.jar || 0).toCashAmount3()} in total gratuities`
                                : "") +
                            `\n\n♒️ Your Family B-Kitty collected ${(this.thank?.pool || 0).toCashAmount3()} in total contributions`
                    );
                };

                this.gold.value = this.thank.gold;
                this.gold.placeholder = "Thank You!";
                this.gold.disabled = true;
                this.gold.classList.add(
                    "text-center",
                    "leading-loose",
                    "font-cursive",
                    "text-2xl",
                    "h-56"
                );
                this.gold.classList.remove("text-lg", "h-40");

                this.footerDate.textContent = this.thank.dateMined
                    ? "Mined on " +
                      this.thank.dateMined.toDate().toFormattedString()
                    : this.thank.dateMinted
                      ? "Minted on " +
                        this.thank.dateMinted.toDate().toFormattedString()
                      : "";
                this.footer.classList.remove("hidden");
                this.footer.classList.add("flex");

                this.goldKarat.textContent =
                    this.thank.karat?.toString() || "0";
                const karat = this.goldKarat.parentElement as HTMLSpanElement;
                karat.onclick = () =>
                    alert(
                        `💛 This B-Thank has ${
                            this.goldKarat.textContent
                        } word${
                            this.goldKarat.textContent === "1" ? "" : "s"
                        } in total`
                    );

                this.goldCarat.textContent =
                    this.thank.carat?.toString() || "0";
                const carat = this.goldCarat.parentElement as HTMLSpanElement;
                carat.onclick = () =>
                    alert(`This B-Thank has a ${this.getCarat()}`);

                this.rethanks.textContent =
                    this.thank.rethankers?.length.toString() || "0";
                const rethanks = this.rethanks.parentElement as HTMLSpanElement;
                const rethanksText =
                    rethanks.lastElementChild as HTMLSpanElement;
                rethanksText.textContent =
                    "Re-thank" + (this.rethanks.textContent === "1" ? "" : "s");
                rethanks.onclick = async () => {
                    if (this.thank?.to) {
                        rethanks.style.opacity = "0.5";
                        let text = "";

                        if (
                            this.thank?.rethankers &&
                            this.thank.rethankers.length > 0
                        ) {
                            for (const [
                                index,
                                uid
                            ] of this.thank.rethankers.entries()) {
                                const isThank =
                                    this.thank.isthanks?.[index] || false;
                                const tip = this.thank.retips?.[index] || 0;
                                const pool = this.thank.repools?.[index] || 0;

                                const minter =
                                    await this.me.getUserProfile(uid);
                                const minterName = tip
                                    ? this.heartbank.user?.uid === uid
                                        ? "YOU as Someone"
                                        : "Someone"
                                    : this.me.getName2(minter);
                                const [minterSign, minterKarat] =
                                    minter.kiitos.numberTuple() || ["", "Zero"];

                                const minerID = isThank
                                    ? this.thank.from!
                                    : this.thank.to;
                                const miner =
                                    await this.me.getUserProfile(minerID);
                                const minerName =
                                    this.heartbank.user?.uid === minerID
                                        ? "YOU"
                                        : this.me.getName2(miner);
                                const [minerSign, minerKarat] =
                                    miner.kiitos.numberTuple() || ["", "Zero"];

                                const gratuity = tip
                                    ? ` and ${isThank ? "donated" : "tipped"} ${tip.toCashAmount3()}${!isThank && pool ? ` and donated ${pool.toCashAmount3()}` : ""} to ${minerName}` +
                                      (isThank && pool
                                          ? ` and contributed ${pool.toCashAmount3()} to your Family B-Kitty`
                                          : "")
                                    : ` to ${minerName}`;

                                text += `\n\n🟨 ${minterName} who's nearby re-gave ${this.thank.rekiitos?.[index]} Kiitos${gratuity} on ${this.thank.redates?.[index].toDate().toFormattedString()}\n\n${getCircle(
                                    minter.kiitos || 0,
                                    true
                                )} ${minterName}'s current Kiitos Balance is ${minterSign + minterKarat} ${getKiitosSummary(minter.kiitos || 0, minterName)}\n\n${getCircle(
                                    miner.kiitos || 0,
                                    true
                                )} ${minerName}'s current Kiitos Balance is ${minerSign + minerKarat} ${getKiitosSummary(miner.kiitos || 0, minerName)}`;
                            }
                        }

                        const total = this.thank?.rethankers?.length || 0;
                        alert(
                            total
                                ? `💛 This B-Thank has ${total} Nearby Re-Thanker${total === 1 ? "" : "s"}:${text}`
                                : `💛 This B-Thank has no Nearby Re-Thankers for ${fromName} or ${toName}`
                        );
                        rethanks.style.opacity = "";
                    } else alert("💛 This B-Thank has no Nearby Re-Thankers");
                };

                const isMined =
                    this.thank.to ||
                    this.thank.from === this.heartbank.user?.uid;
                this.internalBtns.classList.toggle("hidden", !!isMined);
                //this.internalBtns.classList.add("hidden");
                this.mintBtn.classList.add("hidden");
                this.mineBtn.classList.remove("hidden");
                this.externalBtns.classList.toggle("hidden", !isMined);
                //this.external2Btns.classList.toggle("hidden", !isMined);
                this.external2Btns.classList.remove("hidden");

                if (this.thank.to) {
                    const [hasThank, hasReThank] = this.checkThank();
                    const showThank =
                        !this.heartbank.user ||
                        (this.thank.from !== this.heartbank.user.uid &&
                            !hasThank);
                    const showReThank =
                        !this.heartbank.user ||
                        (this.thank.to !== this.heartbank.user.uid &&
                            !hasReThank);

                    this.tokenBtns.classList.add("hidden");
                    //this.tokenBtns.classList.toggle("hidden", showReThank);
                    //this.newBtn.classList.toggle("hidden", showReThank);
                    this.thankBtn.classList.toggle("hidden", !showThank);
                    this.rethankBtn.classList.toggle("hidden", !showReThank);
                    this.thankallBtn.classList.toggle(
                        "hidden",
                        !(showThank && showReThank)
                    );
                    this.thankBtn.innerHTML = `Thank <strong>${await this.me.getName3(this.thank.from!)}</strong>`;
                    this.rethankBtn.innerHTML = `Re-Thank <strong>${await this.me.getName3(this.thank.to)}</strong>`;
                    // if (this.tokenBtns.childElementCount === 0)
                    //     await this.renderTokens();
                } else {
                    this.tokenBtns.classList.add("hidden");
                    //this.newBtn.classList.remove("hidden");
                    this.thankBtn.classList.add("hidden");
                    this.rethankBtn.classList.add("hidden");
                    this.thankallBtn.classList.add("hidden");
                }

                // stats
                this.kiitos.addMiner(this.heartbank.user?.uid || "", id);

                if (
                    !isMined &&
                    confirm(
                        "♒️ The Zero-Point Game ℠ by Miss Aquarius™ AI doesn't just encourage us to express appreciation for others:\n\n❤️‍🔥 It turns gratitude into action!\n\n🔵 Would you like to watch a short video explaining how to play the game?"
                    )
                )
                    window.open("https://youtu.be/rmtNCo8zqlw", "_blank");
            } else window.location.hash = "#/thank";
        } else {
            this.thank = null;

            this.views.classList.add("hidden");
            this.menu.classList.remove("hidden");
            this.archive.classList.remove("hidden");
            this.date.classList.add("hidden");
            this.party.classList.add("hidden");

            const photo = localStorage.getItem("thank-photo");
            if (photo) {
                this.photoImage.src = photo;
                this.photoImageContainer.classList.remove("hidden");
                this.photoUpload.classList.add("hidden");
            } else {
                this.photoImage.removeAttribute("src");
            }

            const poster = localStorage.getItem("thank-poster");
            const short = localStorage.getItem("thank-short");
            if (poster || short) {
                if (poster) this.shortVideo.poster = poster;
                if (short) this.shortVideo.src = short;
                this.shortVideo.controls = true;
                this.shortVideoContainer.classList.remove("hidden");
                this.shortUpload.classList.add("hidden");
            } else {
                this.shortVideo.removeAttribute("poster");
                this.shortVideo.removeAttribute("src");
            }

            this.renderStock(); // needed bc stock is default cover
            //this.stockBtn.click();
            //this.photoBtn.click();
            this.shortBtn.click();
            this.cover.classList.add("hidden");

            this.goldMenu.classList.remove("hidden");
            this.goldMenu.classList.add("inline-flex");
            this.goldLabel.classList.add("hidden");
            this.goldLabel.classList.remove("inline-flex");

            this.gold.value = localStorage.getItem("thank-gold") || "";
            this.gold.placeholder =
                "Optional: Include a Gratitude Note here for Miss Aquarius™ AI to weigh\n\nYour Gold will be publicly stored forever on the Aquarius™ Blockchain"; // based on context and effort
            this.gold.disabled = false;
            this.gold.classList.remove(
                "text-center",
                "leading-loose",
                "font-cursive",
                "text-2xl",
                "h-56"
            );
            this.gold.classList.add("text-lg", "h-40");

            this.footer.classList.add("hidden");
            this.footer.classList.remove("flex");
            this.internalBtns.classList.remove("hidden");
            this.mintBtn.classList.remove("hidden");
            this.mineBtn.classList.add("hidden");
            this.externalBtns.classList.add("hidden");
            this.external2Btns.classList.add("hidden");
            this.tokenBtns.classList.add("hidden");
        }

        this.modal.show();
        this.main.hideSpinner();
    }

    private checkThank(): [boolean, boolean] {
        let hasThank = false;
        let hasReThank = false;

        if (this.thank?.rethankers) {
            for (const [index, rethanker] of this.thank.rethankers.entries()) {
                if (rethanker === this.heartbank.user!.uid) {
                    if (this.thank.isthanks?.[index]) hasThank = true;
                    else hasReThank = true;
                }
            }
        }

        return [hasThank, hasReThank];
    }

    hide() {
        this.modal.hide();
    }

    private async renderTokens(uid: string) {
        const isThankAll = uid === "null";
        const isThank = isThankAll ? null : this.thank?.from === uid;

        const isSenderReThank = this.heartbank.user?.uid === this.thank?.from; // && this.heartbank.user?.uid !== uid;
        this.tokenBtns.innerHTML = "";

        // cancel
        const button = document.createElement("button");
        button.type = "button";
        button.className = `text-white bg-yellow-600 focus:ring-4 focus:outline-none font-medium rounded-lg text-base w-full px-5 py-2.5 text-center`;
        button.innerHTML = `Cancel`;
        button.onclick = () => {
            this.externalBtns.classList.remove("hidden");
            this.external2Btns.classList.remove("hidden");
            this.tokenBtns.classList.add("hidden");
        };
        this.tokenBtns.appendChild(button);

        const profile = await this.me.getUserProfile(uid);
        const name = isThankAll ? "ALL" : this.me.getName2(profile);
        //const name = await this.me.getName3(uid);
        const names = isThankAll
            ? `${await this.me.getName3(this.thank?.from!)} and ${await this.me.getName3(this.thank?.to!)}`
            : "";

        for (const token of TOKENS) {
            const button = document.createElement("button");
            button.type = "button";
            //button.dataset.token = token.token;
            button.className = `text-white ${token.color} focus:ring-4 focus:outline-none font-medium rounded-lg text-base w-full px-5 py-2.5 text-center`;
            button.innerHTML = `Give ${token.emoji} ${isSenderReThank ? "B-Tip" : "Kiitos"} to <strong>${name}</strong>`; //B-Token

            button.onclick = async () => {
                this.main.showSpinner();
                button.disabled = true;
                if (this.heartbank.user && this.hasPasskey) {
                    const tip = isSenderReThank
                        ? getTipAmount(
                              "retip",
                              true,
                              isThank,
                              true,
                              profile,
                              names || name,
                              token.token,
                              this.thank?.kiitos || 0,
                              true,
                              false
                          )
                        : getTipAmount2(
                              isThank,
                              true,
                              profile,
                              names || name,
                              token.token,
                              this.thank?.kiitos || 0
                          );

                    if (!isSenderReThank || tip > 0) {
                        const response = await this.kiitos.rethank(
                            isThankAll ? null : this.thank?.from === uid,
                            this.thank?.id!,
                            token.token,
                            tip
                        );
                        if (response.data) {
                            const index = response.data.rethankers!.lastIndexOf(
                                this.heartbank.user.uid
                            );
                            const kiitos = response.data.rekiitos![index];
                            const tip = response.data.retips![index];
                            const pool = response.data.repools![index];

                            this.thank = response.data;
                            this.thank.kiitos = isThankAll
                                ? kiitos * 2
                                : kiitos;
                            this.thank.tip = isThankAll
                                ? tip
                                : isThank
                                  ? 0
                                  : tip;
                            this.thank.jar = isThankAll
                                ? pool
                                : isThank
                                  ? 0
                                  : pool;
                            this.thank.kitty = isThankAll
                                ? tip
                                : isThank
                                  ? tip
                                  : 0;
                            this.thank.pool = isThankAll
                                ? pool
                                : isThank
                                  ? pool
                                  : 0;

                            this.alertSuccess2(
                                isThank, //this.thank?.from === uid ? uid : "",
                                //isThankAll ? kiitos * 2 : kiitos,
                                response.data.fromBalance!,
                                response.data.toBalance!,
                                response.data.fromName!, // name
                                //isThankAll ? tip * 2 : tip,
                                //isThankAll ? pool * 2 : pool,
                                response.data.toName!, // name
                                isThankAll
                                    ? response.data.thankerBalance
                                    : undefined
                            );

                            const event = new CustomEvent("hb-treasury", {
                                detail: {
                                    isShow: false
                                },
                                bubbles: true,
                                composed: true
                            });
                            this.dispatchEvent(event);

                            await this.show(response.data.id!);
                        } else if (response.color === "red")
                            alert(response.text);
                    }
                } else {
                    if (this.heartbank.user) {
                        if (
                            confirm(
                                `Passkey is required to re-thank ${name}\n\nWould you like to create one now?`
                            )
                        ) {
                            localStorage.setItem(
                                "redirect-lockbox",
                                window.location.hash
                            );
                            window.location.hash = "#/lockbox";
                        }
                    } else {
                        if (
                            confirm(
                                `You need to be logged in to re-thank ${name}\n\nWould you like to log in now?`
                            )
                        ) {
                            localStorage.setItem(
                                "redirect-login",
                                window.location.hash
                            );
                            window.location.hash = "#/login";
                        }
                    }
                }
                button.disabled = false;
                this.main.hideSpinner();
            };

            this.tokenBtns.appendChild(button);
        }
    }

    private alertSuccess2(
        isThank: boolean | null,
        //kiitos: number,
        fromBalance: number,
        toBalance: number,
        fromName: string,
        toName: string,
        //tip: number,
        //pool: number,
        thankerBalance?: number
    ) {
        const [fromSign, fromKarat] = fromBalance.numberTuple() || ["", "Zero"];
        const [toSign, toKarat] = toBalance.numberTuple() || ["", "Zero"];
        const [thankerSign, thankerKarat] = thankerBalance?.numberTuple() || [
            "",
            "Zero"
        ];

        const names =
            thankerBalance === undefined // isThank === null
                ? isThank
                    ? fromName
                    : toName
                : `${fromName} and ${toName}`;
        const balance =
            thankerBalance === undefined
                ? ""
                : `\n\n${getCircle(
                      thankerBalance,
                      true
                  )} ${fromName}'s New Kiitos Balance is ${thankerSign + thankerKarat} ${getKiitosSummary(
                      thankerBalance,
                      fromName
                  )}`;

        const total =
            (this.thank?.tip || 0) +
            (this.thank?.jar || 0) +
            (this.thank?.kitty || 0) +
            (this.thank?.pool || 0);
        const gratuity = total
            ? `and ${isThank ? "donated" : "tipped"} ${total.toCashAmount3()} to ${names}`
            : `to ${names}`;
        const tip = this.thank?.tip
            ? `\n\n🧧 ${toName}'s Personal B-Account received ${this.thank.tip.toCashAmount3()}`
            : "";
        const jar = this.thank?.jar
            ? `\n\n💰 ${toName}'s Retip B-Fund collected ${this.thank.jar.toCashAmount3()}`
            : "";
        const kitty = this.thank?.kitty
            ? `\n\n💰 ${fromName}'s Retip B-Fund collected ${this.thank.kitty.toCashAmount3()}`
            : "";
        const pool = this.thank?.pool
            ? `\n\n♒️ Your Family B-Kitty collected ${this.thank.pool.toCashAmount3()}`
            : "";

        alert(
            `🎉 You have ${
                total ? "anonymously" : "successfully"
            } re-given ${this.thank?.kiitos} Kiitos ${gratuity} as a B-Appreciation!${tip + jar + kitty + pool}\n\n🌎 ${names ? "Their" : toName + "'s"} kindness is now published on the Aquarius™ Blockchain and broadcasted to inspire the world!\n\n${getCircle(
                fromBalance,
                true
            )} Your New Kiitos Balance is ${fromSign + fromKarat} ${getKiitosSummary(
                fromBalance
            )}${balance}\n\n${getCircle(
                toBalance,
                true
            )} ${toName}'s New Kiitos Balance is ${toSign + toKarat} ${getKiitosSummary(
                toBalance,
                toName
            )}\n\n${this.aquarius(fromBalance)}`
        );
    }

    private renderStock() {
        const item = this.page.firstElementChild as HTMLSpanElement;
        const total = this.page.lastElementChild as HTMLSpanElement;
        //console.log(this.stockCategory, this.stockItem, this.stockCount);

        item.textContent = this.stockItem.toString();
        total.textContent = this.stockCount.toString();

        this.stockImage.src = `${TREASURY}/${this.stockCategory}/${this.stockItem}/${this.stockItem}.gif`;
    }

    private goToAI(direction: boolean) {}

    private async goToStock(direction: boolean) {
        if (direction) {
            if (this.stockItem < this.stockCount) {
                ++this.stockItem;
            } else {
                this.stockItem = 1;
            }
        } else {
            if (this.stockItem > 1) {
                --this.stockItem;
            } else {
                this.stockItem = this.stockCount;
            }
        }

        this.renderStock();
    }

    private getUrl() {
        return `${B}/k/${this.thank!.id}`;
    }

    private async getText(isShare: boolean) {
        if (this.thank?.rethankers && this.thank.rethankers.length > 0)
            return "";
        else {
            const profile = this.thank?.to
                ? await this.me.getUserProfile(this.thank?.to)
                : null;
            const name = profile ? this.me.getName2(profile) : null;

            const header = "💛 HeartBank® Thank\n\n";
            const footer = this.thank?.to
                ? `💝 If ${name}'s kindness moves your heart too, tap on the link to re-thank ${name}!`
                : "♒️ If you want to play the Zero-Point Game ℠ by Miss Aquarius™ AI too, tap on the link to mine this B-Thank!";

            const gold = this.thank?.gold ? this.thank.gold + "\n\n" : "";
            const url = isShare ? "" : this.getUrl() + "\n\n";
            const url2 = isShare ? "" : this.getUrl();

            return header + gold + url + footer;
            //return this.thank?.to ? url2 : header + gold + url + footer;
        }
    }

    private async getFile() {
        let file: File | null = null;
        if (
            isIOS &&
            !this.thank?.to &&
            (this.thank?.type === "photo" || this.thank?.type === "short")
        ) {
            const response = await fetch(this.stockImage.src); // `${TREASURY}/${this.stockCategory}/${this.stockItem}/${this.stockItem}.gif`
            const blob = await response.blob();
            file = new File([blob], "B-Thank.gif", { type: "image/gif" });
        }
        return file ? [file] : [];
    }

    private async share(event: Event) {
        event.preventDefault();
        this.shareBtn.disabled = true;

        const shareData = {
            title: "HeartBank® Thank",
            text: await this.getText(true),
            url: this.getUrl(),
            files: await this.getFile()
        };
        //console.log(shareData);

        if (navigator.canShare && navigator.canShare(shareData)) {
            try {
                await navigator.share(shareData);
                console.log("Shared successfully");
            } catch (error: any) {
                if (
                    error.name === "AbortError" ||
                    error.name === "InvalidStateError"
                ) {
                    console.warn("Sharing was cancelled:", error);
                } else {
                    console.error(error);
                }
            }
        } else {
            alert("Sorry, Web Share is not supported on this device.");
        }

        this.shareBtn.disabled = false;
    }
}
